import React from 'react'
import styled, { keyframes } from 'styled-components'

const inAndOut = keyframes`
    30% {
      transform: scale(1.2);
    };
`

const Dot = styled.svg`
    padding: 5px;
    animation: ${inAndOut} 1s forwards;
`
const ActiveTabItem = ({ className, colors }: { className?: string; colors: string[] }) => (
    <Dot width="7px" height="6px" viewBox="0 0 7 6" className={className}>
        <defs>
            <filter
                x="-6.6%"
                y="-6.1%"
                width="113.2%"
                height="112.7%"
                filterUnits="objectBoundingBox"
                id="nav-dot-filter-2"
            >
                <feMorphology radius={0.5} operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
                <feOffset dx={0} dy={2} in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation={15} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix
                    values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.245902535 0"
                    type="matrix"
                    in="shadowBlurOuter1"
                />
            </filter>
            <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="linearGradient-3">
                <stop stopColor={colors[0]} offset="0%" />
                <stop stopColor={colors[1]} offset="100%" />
            </linearGradient>
        </defs>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <g transform="translate(-465.000000, -707.000000)">
                <g id="Browser-BG" transform="translate(47.500000, 32.000000)">
                    <use fill="black" fillOpacity={1} filter="url(#nav-dot-filter-2)" xlinkHref="#path-1" />
                    <use stroke="#BBBBBB" strokeWidth={1} fill="#DFE1E5" fillRule="evenodd" xlinkHref="#path-1" />
                </g>
                <g transform="translate(427.500000, 664.000000)" fill="url(#linearGradient-3)">
                    <g id="Oval" transform="translate(38.420000, 43.020000)">
                        <circle cx={2.87} cy={2.87} r={2.87} />
                    </g>
                </g>
            </g>
        </g>
    </Dot>
)

export default ActiveTabItem
